import React from 'react';
import Ratings from '@hpstellar/core/Ratings'
import Typography from '@hpstellar/core/Typography';

import withPageComponents from '../../../page/components/with-page-components';
import ProductSegmentBadge from '../../../product/components/product-segment-badge';
import ProductPriceV2 from '../../../product/components/product-price/product-price-v2';
import ProductJsonLd  from '../../../product/components/product-json-ld';
import IntraDayDeals from '../../../product/components/deals';
import AddOnPrice from '../../../product/components/product-configurations/addon-price';
import './title-section.less'

const titleSection = ({ product }) => {
    return product ? (<div className={'pdp-title-section'}>
        <ProductJsonLd product={product} />
        <div className={'clearfix review-section'}>
            <Ratings
                className={'float-left'}
                score={product.rating}
                reviewsCount={product.numReviews}
                size='large'
                anchorLink />
            <ProductSegmentBadge
                product={product}
                className={'right'} />
        </div>
        <Typography variant='bodySmall' className={'sku'} tag={'i'}>{product.sku}</Typography>
        <Typography variant='headingTitleLarge' tag={'h1'}>{product.name}</Typography>
        <IntraDayDeals itemId={product.itemId}>
            {dealProps => {
                const { isActive, productDeals } = dealProps;
                const deal = isActive ? productDeals.activeDeal : null;
                return <AddOnPrice sku={product.sku}>
                    {
                        ({ addOnPrice }) => {
                            return <ProductPriceV2
                                product={product}
                                deal={deal}
                                displayDifference={true}
                                addOnPrice={addOnPrice}
                                style={'left'} />
                        }
                    }
                </AddOnPrice>;
            }}
        </IntraDayDeals>
    </div>) : null;
}

export default withPageComponents(titleSection, { components: ['product'] })
